import { bff, createBFFHandlers } from '~/framework/bff';
import { z } from 'zod';
import { getServerSideMonolithClient } from '~/framework';
import { RemoveBulkUsersFromTeamsOptions, removeBulkUsersFromTeams } from '~/monolith-api';

export type { RemoveBulkUsersFromTeamsOptions };

const removeBulkUsersFromTeamsSchema = z.object({
   userIds: z.array(z.number()),
   teamIds: z.array(z.number()),
});

export default createBFFHandlers({
   post: async (req, res) => {
      const { userIds, teamIds } = removeBulkUsersFromTeamsSchema.parse(req.body);
      const monolithClient = getServerSideMonolithClient(req);
      const result = await removeBulkUsersFromTeams({
         userIds: userIds,
         teamIds: teamIds,
         apiClient: monolithClient,
      });
      res.status(201).json(result);
   },
});

export const removeBulkUsersFromTeamsFromClient = ({
   userIds,
   teamIds,
}: RemoveBulkUsersFromTeamsOptions): ReturnType<typeof removeBulkUsersFromTeams> => {
   return bff()
      .post('/users/removeBulkUsersFromTeams', {
         userIds,
         teamIds,
      })
      .then(response => response.data);
};

export type RemoveBulkUsersFromTeamsErrorCode =
   | 'bulk_actions.limit_exceeded'
   | 'bulk_actions.invalid_userids'
   | 'bulk_actions.invalid_teamids';
